import type { FC } from "react";

import { swSettings } from "app/common/services/swSettings";
import WWOSearchTrafficCompare from "app/pages/website-performance/components/SearchTraffic/compare/WWOSearchTrafficCompare";
import { getKeywordsCtaLinkForDS } from "app/pages/website-performance/components/SearchTraffic/utlis";
import { EKeywordTabs } from "app/UtilitiesAndConstants/Constants/SourceTypes";
import { getHooksVersion } from "app/UtilitiesAndConstants/UtilityFunctions/hooksUtils";
import { isNoTouchOrTrialOrAfterTrial } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

interface IWWOSearchTrafficCompareProps {
    organic: boolean;
}

export const WWOSearchTrafficCompareContainer: FC<IWWOSearchTrafficCompareProps> = (props) => {
    return (
        <WWOSearchTrafficCompare
            getCtaLink={(params) =>
                getKeywordsCtaLinkForDS({
                    ...params,
                    selectedPageTab: EKeywordTabs[props.organic ? EKeywordTabs.Organic : EKeywordTabs.Paid],
                })
            }
            unlockHook={{
                component: "WsWebSearchKeywords",
                hookModal: isNoTouchOrTrialOrAfterTrial(swSettings)
                    ? "keywordResearch"
                    : "CompetitveAnalysisOverviewHomepage",
                version: getHooksVersion(swSettings),
            }}
            {...props}
        />
    );
};
